import {NavParams, ViewController} from "ionic-angular";
import {Component} from "@angular/core";
declare var google: any;

@Component({template: `
<ion-header>
  <ion-toolbar>
    <ion-title>
      Mapa de Ruta
    </ion-title>
    <ion-buttons end>
      <button ion-button (click)="dismiss()">
        <span ion-text color="primary">Cancelar</span>
      </button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div id="map" style="width: 100%; height: 100%;"></div>
</ion-content>
`})
export class RouteMapPage {
  markers = [];
  data;
  map;
  positions = [];
  constructor(
    public viewCtrl: ViewController,
    public params: NavParams
  ) {
    this.data = this.params.get('markers');
    this.positions = this.params.get('positions');
  }

  ngOnInit() {
    let bounds = new google.maps.LatLngBounds();
    let infowindow = new google.maps.InfoWindow();
    let mapProp = {
      center: new google.maps.LatLng(51.508742, -0.120850),
      zoom: 5,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    this.map = new google.maps.Map(document.getElementById("map"), mapProp);

    for(let i=0;i<this.positions.length;i++){
      let user = this.data[this.positions[i]];
      if(user){
        bounds.extend(user.location);
        let marker = new google.maps.Marker({
          position: user.location,
          label: String(i+1),
          map: this.map,
          data : user
        });
        this.markers.push(marker);

        google.maps.event.addListener(marker, 'click', ((marker, i) =>{
          return () =>{
            let shipping = (marker.data.charge.shipping) ? "Si" : "No";
            infowindow.setContent('<b>'+marker.data.name+' '+marker.data.lastname+'</b><br>'+marker.data.address+'<br>Posición: <b>'+marker.label+'</b> <br> Despacho : <b>'+shipping+'</b>');
            infowindow.open(this.map, marker);
          }
        })(marker, i));
      }

    }

    this.map.fitBounds(bounds);

  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/routes/map.ts